"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROCESS_INSURANCE_BILLING_RESPONSE_EXAMPLE = exports.PROCESS_CORPORATE_BILLING_RESPONSE_EXAMPLE = exports.BILL_AND_CREATE_PAYMENT_RESPONSE_EXAMPLE = exports.BILL_AGAINST_ADVANCE_RESPONSE_EXAMPLE = exports.COMPUTE_CHARGE_BILLING_RESPONSE_EXAMPLE = void 0;
const financial_common_response_1 = require("./financial-common.response");
const financial_advance_deposit_response_1 = require("./financial-advance-deposit.response");
const financial_payment_response_1 = require("./financial-payment.response");
exports.COMPUTE_CHARGE_BILLING_RESPONSE_EXAMPLE = {
    summary: financial_common_response_1.CHARGE_BILLING_SUMMARY_RESPONSE_EXAMPLE,
    notificationSent: false,
};
exports.BILL_AGAINST_ADVANCE_RESPONSE_EXAMPLE = {
    summary: financial_common_response_1.CHARGE_BILLING_SUMMARY_RESPONSE_EXAMPLE,
    ledgerResult: financial_advance_deposit_response_1.DEBIT_ADVANCE_DEPOSIT_RESPONSE_EXAMPLE,
    notificationSent: false,
};
exports.BILL_AND_CREATE_PAYMENT_RESPONSE_EXAMPLE = {
    summary: financial_common_response_1.CHARGE_BILLING_SUMMARY_RESPONSE_EXAMPLE,
    paymentResult: { ...financial_payment_response_1.CREATE_PAYMENT_RESPONSE_EXAMPLE, payment: { ...financial_payment_response_1.CREATE_PAYMENT_RESPONSE_EXAMPLE.payment, totalAmount: 112100 } },
    notificationSent: false,
};
exports.PROCESS_CORPORATE_BILLING_RESPONSE_EXAMPLE = exports.BILL_AND_CREATE_PAYMENT_RESPONSE_EXAMPLE;
exports.PROCESS_INSURANCE_BILLING_RESPONSE_EXAMPLE = exports.BILL_AND_CREATE_PAYMENT_RESPONSE_EXAMPLE;
//# sourceMappingURL=financial-billing.response.js.map